import React, { useEffect, useRef, useState } from 'react'
import { useFormik } from 'formik';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
// import { adminMainUrl } from '../../Config';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { adminMainUrl } from '../../../../Config';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { getKycDocList } from '../../../../Redux/action/MasterAction';
import { useDispatch } from 'react-redux';
const EditMaster = ({ show, handleClose, onSuccess, kycDocViewData }) => {
    const dispatch = useDispatch();
    const DocTypeOptions = [
        { value: '.doc', label: '.doc' },
        { value: '.docx', label: '.docx' },
        { value: '.rtf', label: '.rtf' },
        { value: '.pdf', label: '.pdf' },
        { value: '.wpd', label: '.wpd' },
        { value: '.jpg', label: '.jpg' },
        { value: '.jpeg', label: '.jpeg' },
        { value: '.png', label: '.png' },
        { value: '.heif', label: '.heif' },
        { value: '.xlsx', label: '.xlsx' },
        { value: '.xls', label: '.xls' },
        { value: '.csv', label: '.csv' },
    ];



    const validationSchema = Yup.object({
        customer_type: Yup.string().required('Customer Type is required'),
        name: Yup.string().required('Document Name is required'),
        doucumentFormat: Yup.array()
            .min(1, 'At least one Document Format is required')
            .required('Document Format is required'),
    });




    const formik = useFormik({
        initialValues: {
            id: '',
            customer_type: '',
            name: '',
            doucumentFormat: [],
            mandatory: false,
        },
        validationSchema,
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            values.id = kycDocViewData?.id
            setSubmitting(true);
            try {
                const response = await fetch(
                    `${adminMainUrl}/api/kyc-doc/update`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "auth-token": Cookies.get("token"), // Assuming token is stored in cookies
                            'user_id': Cookies.get('flexichain_user_id')
                        },
                        body: JSON.stringify(values),
                    }
                );

                const data = await response.json();

                if (response.ok) {
                    setSubmitting(false)


                    toast.success(data?.msg);
                    resetForm();
                    handleClose();
                    if (onSuccess) onSuccess();
                } else {
                    setSubmitting(false)

                    toast.error(data?.msg);
                }
            } catch (error) {
                setSubmitting(false)

                console.error("Network error:", error);
            }

        },
    });

    useEffect(() => {
        if (kycDocViewData) {
            // Assuming kycDocViewData.mandatory is a boolean and kycDocViewData.doucumentFormat is an array of strings
            formik.setValues({
                name: kycDocViewData?.name ?? "",
                customer_type: kycDocViewData?.customer_type ?? "",
                mandatory: kycDocViewData?.mandatory ?? false, // Boolean value
                doucumentFormat: kycDocViewData?.doucumentFormat ? JSON.parse(kycDocViewData.doucumentFormat) : [] // Parse document format if needed
            });
        }
    }, [kycDocViewData]);


    // Handle switch change
    const handleSwitchChange = (e) => {
        formik.setFieldValue('mandatory', e.target.checked);
    };

    return (
        <Offcanvas className="custom-offcanvas" show={show} onHide={handleClose} placement="end">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Edit Kyc Document</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <form onSubmit={formik.handleSubmit}>
                    {/* Customer Type */}
                    <div className="mb-3">
                        <label htmlFor="customer_type" className="form-label">
                            Customer Type <span style={{ color: 'red' }}>*</span>
                        </label>
                        <select
                            className="form-select form-control-sm"
                            id="customer_type"
                            name="customer_type"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.customer_type}
                        >
                            <option value="">Select Customer Type</option>
                            <option >
                                Individual/Proprietary firm
                            </option>
                            <option>
                                Private or Public Limited Company
                            </option>
                            <option>
                                Partnership firm
                            </option>
                        </select>
                        {formik.touched.customer_type && formik.errors.customer_type ? (
                            <div className="error">{formik.errors.customer_type}</div>
                        ) : null}
                    </div>

                    {/* Document Name */}
                    <div className="mb-3">
                        <label htmlFor="name" className="form-label">
                            Document Name <span style={{ color: 'red' }}>*</span>
                        </label>
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            id="name"
                            name="name"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.name}
                        />
                        {formik.touched.name && formik.errors.name ? (
                            <div className="error">{formik.errors.name}</div>
                        ) : null}
                    </div>

                    {/* Document Type (React-Select component) */}
                    <div className="mb-3">
                        <label htmlFor="doucumentFormat" className="form-label">
                            Document Format <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Select
                            closeMenuOnSelect={false}
                            components={makeAnimated()}
                            isMulti
                            options={DocTypeOptions}
                            onChange={(selectedOptions) =>
                                formik.setFieldValue(
                                    'doucumentFormat',
                                    selectedOptions ? selectedOptions.map(option => option.value) : []
                                )
                            }
                            value={DocTypeOptions.filter(option =>
                                formik.values.doucumentFormat?.includes(option.value)
                            )}
                        />
                        {formik.touched.doucumentFormat && formik.errors.doucumentFormat ? (
                            <div className="error">{formik.errors.doucumentFormat}</div>
                        ) : null}
                    </div>


                    {/* Mandatory Switch */}
                    <div className="mb-3">
                        <label className="form-label">
                            Is it mandatory?
                        </label>
                        <div className="form-check form-switch">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="flexSwitchCheckChecked"
                                onChange={handleSwitchChange}
                                checked={formik.values.mandatory}
                            />
                        </div>
                    </div>

                    {/* Submit Button */}
                    <div className="d-flex justify-content-end">
                        <button className="btn btn-primary text-xs" type="submit" disabled={formik.isSubmitting}>
                            {formik.isSubmitting ? <i className="fa fa-spinner fa-spin" /> : 'Submit'}
                        </button>
                    </div>
                </form>
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default EditMaster